module.exports = __webpack_public_path__ + "static/media/anthony.3752d825.jpg";